window.addEventListener('DOMContentLoaded', function () {
  $(document).ready(function () {
    // MENU FOOTER
    $('.Footer__Block .Footer__Title').on('click', function () {
      var $window = $(window);
      var windowsize = $window.width();
      if (windowsize < 769) {
        if ($(this).parents('.Footer__Block').hasClass('open')) {
          $(this).parents('.Footer__Block').find('.Linklist').slideUp();
          $(this).parents('.Footer__Block').removeClass('open');
        } else {
          $('.Linklist').slideUp();
          $('.Footer__Block').removeClass('open');
          $(this).parents('.Footer__Block').find('.Linklist').slideDown();
          $(this).parents('.Footer__Block').addClass('open');
        }
      }
    });
  });
});
